/* eslint-disable prefer-destructuring */
/* eslint-disable import/prefer-default-export */

/**
 * Animate dots circle
 */
function animateDot(splide) {
  const interval = splide.options.interval;
  const page = splide.Components.Pagination.getAt(splide.Components.Controller.getIndex());
  if (!page) return;
  const dot = page.button;

  // Reset progress
  dot.style.setProperty('--progress', '0');

  // Animate the progress from 0% to 100%
  let start = null;
  let paused = false;
  let elapsed = 0;

  const animate = (timestamp) => {
    const splidePaused = splide.Components.Autoplay.isPaused();

    if (splidePaused) {
      paused = true;
      requestAnimationFrame(animate);
      return;
    }

    if (!start) start = timestamp;

    // If the splide was resumed, resume the animation
    if (paused) {
      start = timestamp - elapsed;
      paused = false;
    }

    elapsed = timestamp - start;

    // Calculate the current progress based on the elapsed time (0 to 1)
    const currentProgress = Math.min(elapsed / interval, 1);

    // Update the CSS custom property for progress
    dot.style.setProperty('--progress', currentProgress.toString());

    // Continue the animation if not yet complete
    if (elapsed < interval) {
      requestAnimationFrame(animate);
    } else {
      // Reset when complete
      dot.style.setProperty('--progress', '0');
    }
  };

  requestAnimationFrame(animate);
}

/**
 * Setup dots animation
 */
export function setupSplide(splide) {
  splide.on('mounted', () => {
    animateDot(splide);

    const toggleButton = splide.Components.Elements.toggle;
    if (toggleButton) {
      const pagination = splide.Components.Elements.root.querySelector('.splide__pagination');
      if (pagination) {
        pagination.prepend(toggleButton);
      }
    }
  });

  splide.on('moved', () => {
    animateDot(splide);
  });
}

/**
 * Update the copyright year in the footer
 */
(() => {
  const yearSpan = document.querySelector('.current-year');
  const currentYear = new Date().getFullYear();
  yearSpan.textContent = currentYear;
})();

/**
 * Header
 */
(() => {
  const header = document.querySelector('header');
  const mainHeader = header?.querySelector('.main-header');
  const zoneTop = document.querySelector('.zonetop');
  const heroSlider = document.querySelector('.hero-slider');

  const updateZoneTopMargin = () => {
    zoneTop.style.marginTop = `-${mainHeader.getBoundingClientRect().height}px`;
  };

  // If there is hero-slider in the body, add a negative margin-top
  // to the zonetop equal to the height of the mainHeader
  if (heroSlider) {
    updateZoneTopMargin();
    const resizeObserver = new ResizeObserver(() => {
      updateZoneTopMargin();
    });
    resizeObserver.observe(mainHeader);
    window.addEventListener('resize', () => {
      updateZoneTopMargin();
    });
  }

  const searchContainer = header?.querySelector('.widgetsearch');
  const searchButton = searchContainer?.querySelector('button');
  if (!searchButton) return;

  searchButton.addEventListener('click', (e) => {
    if (searchContainer.classList.contains('expanded')) return;
    e.preventDefault();
    searchContainer.classList.add('expanded');
  });

  window.addEventListener('click', (e) => {
    if (searchContainer.classList.contains('expanded') && !searchContainer.contains(e.target)) {
      searchContainer.classList.remove('expanded');
    }
  });
})();

/**
 * Transparent Header - Hero Static
 */
(() => {
  const header = document.querySelector('header');
  const mainHeader = header?.querySelector('.main-header');
  const zoneTop = document.querySelector('.zonetop');
  const heroStatic = document.querySelector('.hero-static');

  const updateZoneTopMargin = () => {
    zoneTop.style.marginTop = `-${mainHeader.getBoundingClientRect().height}px`;
  };

  // If there is hero-static in the body, add a negative margin-top
  // to the zonetop equal to the height of the mainHeader
  if (heroStatic) {
    updateZoneTopMargin();
    const resizeObserver = new ResizeObserver(() => {
      updateZoneTopMargin();
    });
    resizeObserver.observe(mainHeader);
    window.addEventListener('resize', () => {
      updateZoneTopMargin();
    });
  }
})();
